import styled, { css } from 'styled-components';
import { getColor, StyleVars } from 'core/utils/Styles';
import Btn from 'core/ui/Button';

export const desktop = (...args) => css`
	@media (min-width: 1024px) {
		${css(...args)}
	}
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	border: 1px solid ${getColor('gray2')};
	border-radius: ${StyleVars.defaultBorderRadius};
	text-align: center;
	margin-bottom: 8px;
	padding: 24px;

	${desktop`
		margin-bottom: 16px;
		padding: 40px;
	`}
`;

export const Heading = styled.h4`
	font-size: 19px;

	${desktop`
		font-size: 22px;
	`}
`;

export const Text = styled.p`
	color: ${getColor("gray")};
	font-size: 14px;
	line-height: 1.57;
	letter-spacing: 0.2px;
	margin-bottom: 24px;
`;

export const Button = styled(Btn)`
	width: 100%;

	${desktop`
		width: auto;
		padding: 0 44px;
	`}
`;
